import DataTable from "react-data-table-component";
import { mergeTableStyles } from "./tableTheme";
import "./AppDataTable.css";

const defaultPaginationComponentOptions = {
  rowsPerPageText: "Filas:",
  rangeSeparatorText: "de",
  selectAllRowsItem: true,
  selectAllRowsItemText: "Todos",
};

const AppDataTable = ({
  noScroll = true,
  scrollHeight = "65vh",
  tableWrapperClassName = "",
  customStyles,
  noDataComponent,
  paginationComponentOptions,
  dense = true,
  ...props
}) => {
  const bodyClassName = noScroll
    ? "app-data-table__body app-data-table__body--fluid"
    : "app-data-table__scroll";

  return (
    <div className={`app-data-table ${tableWrapperClassName}`}>
      <div
        className={bodyClassName}
        style={noScroll ? undefined : { maxHeight: scrollHeight }}
      >
        <DataTable
          className="app-data-table__rdt"
          responsive
          striped
          dense={dense}
          highlightOnHover
          pointerOnHover
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 25, 50, 100]}
          customStyles={mergeTableStyles(customStyles)}
          paginationComponentOptions={{
            ...defaultPaginationComponentOptions,
            ...paginationComponentOptions,
          }}
          noDataComponent={
            noDataComponent ?? <p className="table-empty">No hay registros.</p>
          }
          {...props}
        />
      </div>
    </div>
  );
};

export default AppDataTable;
